export default __webpack_public_path__ + "static/media/img--design-8.481d8db8.jpg";